import {useHistory} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {constants, customStyles, REPORT_TYPES} from "../../utils/constants";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {Col, Dropdown, DropdownButton, FormControl, InputGroup, Row} from "react-bootstrap";
import {MenuDots, SearchIcon} from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";
import {GetReports} from "../../services/reports.service";
import moment from "moment";
import DataTableExtensions from "react-data-table-component-extensions";
import {EmptyState} from "../../components/EmptyState";


function Reports(props) {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState()
    const [keyword, setKeyword] = useState('');

    useEffect(async () => {
        await getReports();
    }, [keyword, page, perPage])

    const getReports = async () => {
        setLoading(true)
        await GetReports(keyword, page, perPage).then((result) => {
            if (result.status) {
            if (result.data) {
                const rowData = [];
                setTotalRows(result.data?.pagination?.total);
                let counter = 1; // Initialize the counter to start from 1
                result.data.data.map((dt, index) => {
                    rowData.push({
                        id: counter++,
                        _id:dt._id || '-',
                        user_name: dt?.user?.fullName  || '-',
                        report_type: dt?.type?.name || '-',
                        report_content : (dt?.module === REPORT_TYPES.STREAMING)? dt?.post.name:dt?.post.title || '-',
                        // status: dt?.duration,
                        created_at: moment(dt?.created_at).fromNow(),

                    });

                })
                setRows(rowData);
                setLoading(false)
            }
            }
            else {
                setLoading(false)
                return toast.error(result.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.message);
            }
        })
    }

    const onView = (data) => {
        history.push('/reports/view-detail/' + data._id, {
            data: data
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="start" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onView(data)}>View Detail</Dropdown.Item>
            </DropdownButton>
        )
    }

    const columns = [
        {
            id: 'id',
            name: 'Id',
            maxWidth: '60px',
            center: true,
            sortable: true,
            selector: rowData => rowData.id,
            cellExport: rowData => rowData.id,
        },
        {
            id: 'user_name',
            name: 'User',
            width: '180px',
            sortable: true,
            selector: rowData => rowData.user_name,
            cellExport: rowData => rowData.user_name,
        },
        {
            id: 'report_type',
            name: 'Type',
            center: true,
            width: '120px',
            selector: rowData => rowData.report_type,
            cellExport: rowData => rowData.report_type,
        },
        {
            id: 'report_content',
            name: 'Content',
            width: '220px',
            grow: true,
            center: true,
            selector: rowData => rowData.report_content,
            cellExport: rowData => rowData.report_content,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
            cellExport: rowData => rowData.created_at,
        },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData),
            export: false
        },
    ];

    return (
        <div className={"transactionsPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Reports</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        {/*{rows && rows.length > 0 ? (*/}
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onChange={(e) => {
                                    (e.target.value.length > 2) ? setKeyword(e.target.value) : setKeyword(null)
                                }}
                            />
                        </InputGroup>
                        {/*) : ('')}*/}
                    </Col>
                    <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}>

                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>

                    </Col>
                </Row>

            </div>
            <div className="theme-dataGrid products-dataGrid">
                {rows && rows.length == 0 ? (
                    <EmptyState/> // Render the EmptyState component when there are no records
                ): (
                <DataTableExtensions
                    columns={columns}
                    data={rows}
                    filter={false}
                    print={false}
                    exportHeaders
                    fileName='Reports'
                >
                <DataTable
                    pagination
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover

                    paginationServer
                    paginationTotalRows={totalRows}

                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#f39633'} loading={loading} css={'marginTop: 10px'}
                                                  height={'4'} width={'100%'} />}
                />
                </DataTableExtensions>
                )}
            </div>
        </div>
    )
}

export default Reports;